import styled from 'styled-components';

const VendorPartnerLogosStyles = styled.div`
    h1 {
        font-size: 18px;
        font-weight: 800;
        line-height: 25px;
        padding-bottom: 30px;
        padding-top: 30px;
        text-align: center;
    }

    .Logo__container {
        padding: 16px;
    }

    .Logo__container a {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 150px;
        width: 100%;
    }

    .Logo__container .gatsby-image-wrapper {
        width: 100%;
        max-width: 220px;
        height: 120px;
    }

    .Logo__container .gatsby-image-wrapper img {
        object-fit: contain !important;
        object-position: center !important;
    }

    .Logo__container a:focus-visible {
        outline: 2px solid ${props => props.theme.orange};
        outline-offset: 4px;
    }
`;

export default VendorPartnerLogosStyles;
